import { client } from "@/utils/client";

export function addServer(domain, alexa_server, domain_server, token) {
    const data = {
        domain,
        alexa_server,
        domain_server,
        token
    }
    return client({
        url: "/console/server",
        method: "post",
        data
    })
}

export function modifyServer(domain, alexa_server, domain_server, token) {
    const data = {
        domain,
        alexa_server,
        domain_server,
        token
    }
    return client({
        url: "/console/server",
        method: "put",
        data
    })
}

export function deleteServer(query) {
    return client({
        url: "/console/server?" + query,
        method: "delete",
    })
}


//////////////////
// WEBPACK FOOTER
// ./src/api/server.js
// module id = null
// module chunks = 